import { FC } from 'react';
import { ReleaseAndDeployments } from '@agilelab/plugin-wb-builder-common';
import { WbCardContent, WbTable } from '@agilelab/plugin-wb-platform';
import { useRouteRef } from '@backstage/core-plugin-api';
import { Box } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { releaseDetailRouteRef } from '../../routes';
import { getReleaseInfo } from '../../utils';
import { useReleasePageContext } from './context/useReleasePageContext';
import { useReleasesTableColumns } from './hooks/useReleasesTableColumns';
import { ReleaseFilters } from './ReleaseFilters';
import { ReleaseTableNoData } from './ReleaseTableNoData';

export const ReleaseTable: FC = () => {
  const { releasesState, releases } = useReleasePageContext();
  const navigate = useNavigate();
  const releaseDetailRoute = useRouteRef(releaseDetailRouteRef);
  const columns = useReleasesTableColumns();

  const hasData = !!releasesState?.value && !!releases?.length;

  return (
    <WbCardContent
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
    >
      {hasData && (
        <Box
          style={{
            display: 'flex',
          }}
        >
          <Box style={{ width: '100%' }}>
            <ReleaseFilters />
          </Box>
        </Box>
      )}

      <WbTable<ReleaseAndDeployments>
        stickyHeader
        components={{
          tableLoader: {
            loading: releasesState?.loading,
          },
          tableContent: {
            onRowClick: release => {
              const { kind, namespace, name } = getReleaseInfo(release);

              navigate(releaseDetailRoute({ kind, namespace, name }));
            },
            columns,
            rows: releasesState?.value ? releases : undefined,
          },
        }}
        noDataComponent={<ReleaseTableNoData />}
        styles={{
          container: { flex: '1 1 0' },
        }}
      />
    </WbCardContent>
  );
};
